import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/purchase_orders',
    name: 'PurchaseOrders',
    component: {
      name: 'AdminPurchaseOrder',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'purchase_order',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminPurchaseOrderIndex',
        component: () => import('../views/PurchaseOrderAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminPurchaseOrderNew',
        component: () => import('../views/PurchaseOrderAdminInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminPurchaseOrderIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminPurchaseOrderShow',
        component: () => import('../views/PurchaseOrderAdminShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminPurchaseOrderIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminPurchaseOrderDetails',
            component: () => import('../views/PurchaseOrderAdminDetails.vue'),
            meta: {
              backRoute: { name: 'AdminPurchaseOrderIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminPurchaseOrderEdit',
            component: () => import('../views/PurchaseOrderAdminInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminPurchaseOrderDetails' },
            },
          },
          {
            path: 'send',
            name: 'AdminPurchaseOrderSend',
            component: () => import('../views/PurchaseOrderAdminSendInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminPurchaseOrderEdit', query: { step: 1 } },
            },
          },
          {
            path: 'delivered_items/edit',
            name: 'AdminDeliveredItemEdit',
            component: () => import('../views/deliveredItem/DeliveredItemAdminInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminPurchaseOrderDetails' },
            },
          },
          {
            path: 'delivered_items',
            name: 'AdminDeliveredItems',
            component: () => import('../views/deliveredItem/PurchaseOrderDeliveredItems.vue'),
            meta: {
              backRoute: { name: 'AdminPurchaseOrderIndex' },
              customName: 'views.purchase_order.received_items',
              resource: 'purchase_order_line',
            },
          },
          {
            path: 'processed_document_connections',
            name: 'AdminPurchaseOrderProcessedDocumentConnections',
            component: () => import('../views/processedDocumentConnection/PurchaseOrderProcessedDocumentConnections.vue'),
            meta: {
              backRoute: { name: 'AdminPurchaseOrderIndex' },
              resource: 'incoming_invoice',
            },
          },
          {
            path: 'attachments',
            name: 'AdminPurchaseOrderAttachments',
            component: () => import('../views/attachment/PurchaseOrderAttachments.vue'),
            meta: {
              backRoute: { name: 'AdminPurchaseOrderIndex' },
              resource: 'attachment',
            },
          },
          {
            path: 'attachments/edit',
            name: 'AdminPurchaseOrderAttachmentsEdit',
            component: () => import('../views/attachment/PurchaseOrderAttachmentsInput.vue'),
            meta: {
              backRoute: { name: 'AdminPurchaseOrderAttachments' },
              resource: 'attachment',
              action: 'edit',
            },
          },
          {
            path: 'phases',
            name: 'AdminPurchaseOrderPhases',
            component: () => import('../views/PurchaseOrderPhases.vue'),
            meta: {
              backRoute: { name: 'AdminPurchaseOrdersIndex' },
              resource: 'phase',
            },
          },
          {
            path: 'logs',
            name: 'AdminPurchaseOrderLogs',
            component: () => import('../views/log/PurchaseOrderLogs.vue'),
            meta: {
              backRoute: { name: 'AdminPurchaseOrderIndex' },
              resource: 'log',
            },
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));